module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn btn-default btn-lg",
    on: {
      "click": function($event) {
        _vm.openModal()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "folder-open"
    }
  }), _vm._v(" Select tutorial")], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "title": "Select tutorial",
      "large": ""
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    staticClass: "modal-body",
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, _vm._l((_vm.tutorials), function(section) {
    return (_vm.tutorials) ? _c('div', [_c('h4', [_c('icon', {
      attrs: {
        "name": section.icon
      }
    }), _vm._v(" " + _vm._s(section.name))], 1), _vm._v(" "), _vm._l((section.tutorials), function(tutorial) {
      return _c('radio', {
        attrs: {
          "selected-value": tutorial,
          "type": "success"
        },
        model: {
          value: (_vm.selected),
          callback: function($$v) {
            _vm.selected = $$v
          },
          expression: "selected"
        }
      }, [_vm._v(_vm._s(tutorial))])
    })], 2) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(!_vm.selected) ? _c('div', [_c('h4', [_vm._v("Just pick a tutorial from the list on the left...")])]) : _vm._e(), _vm._v(" "), (_vm.selected) ? _c('div', [_c('tutorialDetails', {
    ref: "tutorialDetails",
    attrs: {
      "name": _vm.selected,
      "helper": _vm.helper
    }
  })], 1) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.loadTutorial()
      }
    }
  }, [_vm._v("Start tutorial")])])]), _vm._v(" "), (!_vm.session) ? _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showStartHere) ? _c('img', {
    attrs: {
      "src": require("../../assets/starthere.png")
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.session) ? _c('div', [_c('h4', {
    staticClass: "page-header"
  }, [_vm._v(_vm._s(_vm.session.tutorial.definition.name))]), _vm._v(" "), (_vm.session.tutorial.definition.guide) ? _c('resourceTemplate', {
    attrs: {
      "resource": _vm.session.tutorial.resources[_vm.session.tutorial.definition.guide]
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ca8b5f9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tutorialPicker/TutorialPicker.vue
// module id = 1545
// module chunks = 2